"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var storeTagApi = _interopRequireWildcard(require("@/api/storeTagApi.js"));
var _systemSetting = require("@/api/systemSetting.js");
var _validate = require("@/utils/validate");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t3 in e) "default" !== _t3 && {}.hasOwnProperty.call(e, _t3) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t3)) && (i.get || i.set) ? o(f, _t3, i) : f[_t3] = e[_t3]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var MAX_IMAGE_SIZE = 100 * 1024;
var MAX_IMAGE_SIZE_ERROR = '请上传大小≤100KB的图片！';
var LABEL_NAME_REG = /^[\u4e00-\u9fa5]+$/;
var _default = exports.default = {
  data: function data() {
    var validateLabelName = function validateLabelName(rule, value, callback) {
      var text = (value || '').trim();
      if (!text) {
        callback(new Error('请填写标签名称'));
        return;
      }
      if (text.length > 20) {
        callback(new Error('标签名称最多20个字符'));
        return;
      }
      if (!LABEL_NAME_REG.test(text)) {
        callback(new Error('标签名称仅支持文字'));
        return;
      }
      callback();
    };
    return {
      loading: false,
      visible: false,
      userType: null,
      pram: this.getDefaultForm(),
      labelNameRules: [{
        required: true,
        validator: validateLabelName,
        trigger: ['blur', 'change']
      }],
      productSourceRules: [{
        required: true,
        message: '请选择商品来源',
        trigger: ['blur', 'change']
      }],
      backgroundImageRules: [{
        required: true,
        message: '请上传背景图',
        trigger: ['blur', 'change']
      }],
      statusRules: [{
        required: true,
        message: '请选择状态',
        trigger: ['blur', 'change']
      }]
    };
  },
  mounted: function mounted() {
    try {
      var JavaInfo = JSON.parse(_jsCookie.default.get('JavaInfo'));
      this.userType = JavaInfo.type;
    } catch (e) {
      this.userType = null;
    }
  },
  methods: {
    handleLabelNameValidate: function handleLabelNameValidate() {
      var _this = this;
      this.$nextTick(function () {
        _this.$refs.pram && _this.$refs.pram.validateField('labelName');
      });
    },
    getDefaultForm: function getDefaultForm() {
      return {
        labelName: '',
        productSource: 1,
        scope: ['1'],
        backgroundImage: '',
        status: 1,
        isHome: 0
      };
    },
    normalizeForm: function normalizeForm() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _objectSpread(_objectSpread(_objectSpread({}, this.getDefaultForm()), data), {}, {
        productSource: 1,
        scope: ['1'],
        labelName: data.labelName || '',
        backgroundImage: data.backgroundImage || data.bgImg || '',
        status: data.status !== undefined && data.status !== null ? data.status : 1,
        isHome: data.isHome || 0
      });
    },
    openInit: function () {
      var _openInit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this2 = this;
        var tagDetails,
          data,
          detail,
          _args = arguments,
          _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              tagDetails = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              data = _objectSpread({}, tagDetails);
              if (!tagDetails.id) {
                _context.n = 4;
                break;
              }
              _context.p = 1;
              _context.n = 2;
              return storeTagApi.getDetail(tagDetails.id);
            case 2:
              detail = _context.v;
              data = _objectSpread(_objectSpread({}, data), detail || {});
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
            case 4:
              this.pram = this.normalizeForm(data);
              this.visible = true;
              this.$nextTick(function () {
                _this2.$refs.pram && _this2.$refs.pram.clearValidate();
              });
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function openInit() {
        return _openInit.apply(this, arguments);
      }
      return openInit;
    }(),
    handerSubmit: (0, _validate.Debounce)(function (form) {
      var _this3 = this;
      this.$refs[form].validate(function (valid) {
        if (!valid) return;
        _this3.loading = true;
        var payload = _objectSpread(_objectSpread({}, _this3.pram), {}, {
          labelName: (_this3.pram.labelName || '').trim(),
          scope: ['1'],
          isHome: 0
        });
        storeTagApi[_this3.pram.id ? 'UpdateArticle' : 'AddArticle'](payload).then(function () {
          _this3.$message.success('操作成功');
          _this3.loading = false;
          _this3.visible = false;
          _this3.$emit('doRefresh');
        }).catch(function () {
          _this3.loading = false;
        });
      });
    }),
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    handleDialogClose: function handleDialogClose() {
      this.pram = this.getDefaultForm();
    },
    getMaterialImageUrl: function getMaterialImageUrl(imageData) {
      if (!imageData) return '';
      return imageData.attDir || imageData.sattDir || imageData.url || '';
    },
    modalPicTap: function modalPicTap() {
      var _this4 = this;
      this.$modalUpload(function (img) {
        if (!_this4.validateImageData(img[0])) return;
        _this4.$set(_this4.pram, 'backgroundImage', _this4.getMaterialImageUrl(img[0]));
        _this4.$refs.pram && _this4.$refs.pram.validateField('backgroundImage');
      }, '1', 'system', true, {
        maxSizeKB: 100,
        maxSizeErrorMsg: MAX_IMAGE_SIZE_ERROR
      });
    },
    removeImg: function removeImg() {
      this.$set(this.pram, 'backgroundImage', '');
      this.$refs.pram && this.$refs.pram.validateField('backgroundImage');
    },
    beforeUpload: function beforeUpload(file) {
      if (!this.isPngOrJpgFile(file)) {
        this.$message.error('仅支持上传 png/jpg 格式图片！');
        return false;
      }
      if (file.size > MAX_IMAGE_SIZE) {
        this.$message.error(MAX_IMAGE_SIZE_ERROR);
        return false;
      }
      return true;
    },
    isPngOrJpgFile: function isPngOrJpgFile(file) {
      var allowedMimes = ['image/png', 'image/jpeg', 'image/jpg'];
      if (file.type && allowedMimes.includes(file.type.toLowerCase())) {
        return true;
      }
      var name = (file.name || '').toLowerCase();
      return /\.(png|jpe?g)$/.test(name);
    },
    isPngOrJpgAttachment: function isPngOrJpgAttachment(imageData) {
      if (!imageData) return true;
      var allowedMimes = ['image/png', 'image/jpeg', 'image/jpg'];
      var mime = (imageData.type || '').toLowerCase();
      if (mime) {
        return allowedMimes.includes(mime);
      }
      var attType = (imageData.attType || '').toLowerCase();
      if (attType) {
        if (attType.includes('video')) return false;
        if (allowedMimes.includes(attType)) return true;
        if (['png', 'jpg', 'jpeg'].includes(attType)) return true;
        if (attType.includes(',')) return true;
        return false;
      }
      var url = imageData.attDir || imageData.sattDir || imageData.url || '';
      if (/\.(png|jpe?g)(\?|$)/i.test(url)) return true;
      return true;
    },
    validateImageData: function validateImageData(imageData) {
      if (!imageData) return true;
      if (!this.isPngOrJpgAttachment(imageData)) {
        this.$message.error('仅支持上传 png/jpg 格式图片！');
        return false;
      }
      var sizeBytes = this.parseAttachmentSizeBytes(imageData);
      if (sizeBytes != null && sizeBytes > MAX_IMAGE_SIZE) {
        this.$message.error(MAX_IMAGE_SIZE_ERROR);
        return false;
      }
      return true;
    },
    parseAttachmentSizeBytes: function parseAttachmentSizeBytes(item) {
      if (!item) return null;
      var raw = item.attSize || item.att_size || item.fileSize || item.size;
      if (raw == null || raw === '') return null;
      if (typeof raw === 'number') {
        return raw > 1024 * 500 ? raw : raw * 1024;
      }
      var str = String(raw).trim();
      var kbMatch = str.match(/^([\d.]+)\s*KB$/i);
      if (kbMatch) return parseFloat(kbMatch[1]) * 1024;
      var mbMatch = str.match(/^([\d.]+)\s*MB$/i);
      if (mbMatch) return parseFloat(mbMatch[1]) * 1024 * 1024;
      var num = parseFloat(str);
      if (!isNaN(num)) return num;
      return null;
    },
    handleLocalUpload: function () {
      var _handleLocalUpload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(options) {
        var file, formData, loading, res, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              file = options.file;
              if (this.beforeUpload(file)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              formData = new FormData();
              formData.append('multipart', file);
              loading = this.$loading({
                lock: true,
                text: '上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              _context2.p = 2;
              _context2.n = 3;
              return (0, _systemSetting.fileImageApi)(formData, {
                model: 'product',
                pid: 1
              });
            case 3:
              res = _context2.v;
              loading.close();
              if (res && res.url) {
                this.$set(this.pram, 'backgroundImage', res.url);
                this.$refs.pram && this.$refs.pram.validateField('backgroundImage');
                this.$message.success('上传成功');
              } else {
                this.$message.error('上传失败，请重试');
              }
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t2 = _context2.v;
              loading.close();
              this.$message.error('上传失败：' + (_t2.message || '请重试'));
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[2, 4]]);
      }));
      function handleLocalUpload(_x) {
        return _handleLocalUpload.apply(this, arguments);
      }
      return handleLocalUpload;
    }()
  }
};